module.exports = __webpack_public_path__ + "img/EC.b526c480.svg";